import * as actions from './actions';

const bookingStatusModule = {
  namespaced: true,
  actions,
};

export default bookingStatusModule;
